/**
 * TE pipeline / video debug flag (mirrors trainingHrDebugLog.js).
 *
 * Enable:
 *   ?teDebug=1  or  ?trainingTeDebug=1
 *   localStorage.setItem('SMARTTT_TE_DEBUG', '1'); location.reload();
 *   REACT_APP_SMARTTT_TE_DEBUG=1
 */

const STORAGE_KEYS = ["SMARTTT_TE_DEBUG", "SMARTTT_TRAINING_TE_DEBUG"];

function parseTriState(raw) {
  if (raw == null) return null;
  const s = String(raw).trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(s)) return true;
  if (["0", "false", "no", "off"].includes(s)) return false;
  return null;
}

function storageTriState(getter) {
  for (const key of STORAGE_KEYS) {
    const v = parseTriState(getter(key));
    if (v !== null) return v;
  }
  return null;
}

function urlDebugEnabled() {
  try {
    const q = new URLSearchParams(window.location.search);
    for (const param of ["teDebug", "trainingTeDebug"]) {
      const v = parseTriState(q.get(param));
      if (v === true) return true;
      if (v === false) return false;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function isTrainingTeDebugEnabled() {
  if (typeof window === "undefined") return false;
  try {
    if (window.__SMARTTT_TE_DEBUG__ === true) return true;

    const fromUrl = urlDebugEnabled();
    if (fromUrl === true) return true;
    if (fromUrl === false) return false;

    const fromLocal = storageTriState((k) => localStorage.getItem(k));
    if (fromLocal === true) return true;
    if (fromLocal === false) return false;

    if (parseTriState(process.env.REACT_APP_SMARTTT_TE_DEBUG) === true) {
      return true;
    }

    return false;
  } catch {
    return false;
  }
}

export function trainingTeDebugLog(section, data) {
  if (!isTrainingTeDebugEnabled()) return;
  console.log(`[SmartTT TE Pipeline] ${section}`, data);
}
